import * as Sentry from '@sentry/vue'

function parseTracingOrigins(originsStr) {
  const origins = originsStr
    ? originsStr
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)
    : []
  return ['localhost', ...origins, /^\//]
}

export function useMonitor() {
  function initReportLimitStorage() {
    if (!sessionStorage.getItem('sentry_report_limit')) {
      const reportLimit = {
        JS_EXIST_URI: []
      }
      sessionStorage.setItem('sentry_report_limit', JSON.stringify(reportLimit))
    }
    const reportLimit = sessionStorage.getItem('sentry_report_limit')
    return JSON.parse(reportLimit)
  }

  function initSentryConfig() {
    const sentryHost = import.meta.env.VITE_SENTRY_HOST
    const dsn = sentryHost ? `https://39254067b3f54970b5254dfaf567a8ae@${sentryHost}/4` : ''
    const releaseEnv = import.meta.env.VITE_SENTRY_RELEASE_ENV
    const env = import.meta.env.VITE_SENTRY_ENV
    const tracingOrigins = parseTracingOrigins(import.meta.env.VITE_SENTRY_TRACING_ORIGINS)
    return {
      dsn,
      env,
      tracingOrigins,
      releaseEnv
    }
  }

  function startMonitor({ app, router }) {
    const { dsn, env, tracingOrigins, releaseEnv } = initSentryConfig()

    console.log('releaseEnv', tracingOrigins, import.meta.env.VITE_APP_ENV)

    if (dsn && tracingOrigins?.length) {
      // 初始化Sentry监控
      Sentry.init({
        app,
        dsn, // 后续根据环境变量来变动
        integrations: [
          new Sentry.BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins
          })
        ],
        release: releaseEnv + '@1.0.0',
        tracesSampleRate: 1.0,
        environment: env
      })

      // 添加全局unhandledrejection事件监听
      window.addEventListener('unhandledrejection', (event) => {
        const message = typeof event.reason === 'object' ? event.reason?.message || 'promise异步错误' : event.reason
        const error = event.reason instanceof Error ? event.reason : new Error(message)
        Sentry.captureException(error, { extra: { sourceType: 'promise', originalRejection: event.reason } })
      })
      // vue的全局错误监听
      app.config.errorHandler = (err) => {
        const error = err instanceof Error ? err : new Error(err?.message || 'Vue全局监听检测到错误')
        Sentry.captureException(error, { extra: { sourceType: 'vue' } })
      }
      // window的error监听
      window.addEventListener(
        'error',
        (event) => {
          // 限制同一个资源上报次数
          const reportLimit = initReportLimitStorage()
          const tagNameWhiteList = ['VIDEO', 'IMG', 'AUDIO', 'SOURCE', 'SCRIPT', 'STYLE', 'LINK']
          // 去除一些不需要上报的资源
          if (!tagNameWhiteList.includes(event?.target?.tagName)) {
            // JavaScript 运行时错误
            const errorMessage = event.message
            const errorInfo = event.error instanceof Error ? event.error : new Error(event.message || 'js error')
            const isExist = reportLimit.JS_EXIST_URI.includes(errorMessage)

            // console.log('Error message:', event, isExist)
            // console.log('tagName', event?.target?.tagName)

            // 你可以在这里将错误信息发送到 Sentry 或其他错误监控服务
            if (!errorMessage || !isExist) {
              Sentry.captureException(errorInfo, { extra: { sourceType: event?.target?.tagName || 'window' } })
              if (errorMessage) {
                reportLimit.JS_EXIST_URI.push(errorMessage)
              }
            }
          }
          sessionStorage.setItem('sentry_report_limit', JSON.stringify(reportLimit))
        },
        true
      )
    }
  }

  return {
    startMonitor
  }
}
